@file:OptIn(InternalResourceApi::class)

package nnod.landing.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/nnod.landing.generated.resources/"

@delegate:ResourceContentHash(53_491_381)
internal val Res.string.landing_brand: StringResource by lazy {
      StringResource("string:landing_brand", "landing_brand", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 10, 29),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 10, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 29),
      ))
    }

@delegate:ResourceContentHash(1_083_821_995)
internal val Res.string.landing_footer: StringResource by lazy {
      StringResource("string:landing_footer", "landing_footer", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 40, 34),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 40, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 40, 34),
      ))
    }

@delegate:ResourceContentHash(1_268_666_191)
internal val Res.string.landing_tagline: StringResource by lazy {
      StringResource("string:landing_tagline", "landing_tagline", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 75, 59),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 75, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75, 71),
      ))
    }

@delegate:ResourceContentHash(1_337_022_852)
internal val Res.string.nodin_code_input_label: StringResource by lazy {
      StringResource("string:nodin_code_input_label", "nodin_code_input_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 135, 54),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 147, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 147, 62),
      ))
    }

@delegate:ResourceContentHash(1_977_015_656)
internal val Res.string.nodin_display_code_label: StringResource by lazy {
      StringResource("string:nodin_display_code_label", "nodin_display_code_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 190, 48),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 210, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210, 52),
      ))
    }

@delegate:ResourceContentHash(-1_124_363_396)
internal val Res.string.nodin_end_badge: StringResource by lazy {
      StringResource("string:nodin_end_badge", "nodin_end_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 239, 39),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 263, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 263, 39),
      ))
    }

@delegate:ResourceContentHash(1_792_197_474)
internal val Res.string.nodin_end_expired_body: StringResource by lazy {
      StringResource("string:nodin_end_expired_body", "nodin_end_expired_body", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 279, 78),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 303, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 303, 106),
      ))
    }

@delegate:ResourceContentHash(481_238_649)
internal val Res.string.nodin_end_expired_title: StringResource by lazy {
      StringResource("string:nodin_end_expired_title", "nodin_end_expired_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 358, 59),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 410, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 410, 91),
      ))
    }

@delegate:ResourceContentHash(-1_704_538_758)
internal val Res.string.nodin_end_not_found_body: StringResource by lazy {
      StringResource("string:nodin_end_not_found_body", "nodin_end_not_found_body", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 418, 72),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 502, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 502, 92),
      ))
    }

@delegate:ResourceContentHash(-43_539_363)
internal val Res.string.nodin_end_not_found_title: StringResource by lazy {
      StringResource("string:nodin_end_not_found_title", "nodin_end_not_found_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 491, 57),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 595, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 595, 85),
      ))
    }

@delegate:ResourceContentHash(348_695_061)
internal val Res.string.nodin_end_time_label: StringResource by lazy {
      StringResource("string:nodin_end_time_label", "nodin_end_time_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 549, 40),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 681, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 681, 44),
      ))
    }

@delegate:ResourceContentHash(541_616_714)
internal val Res.string.nodin_instructions_step1: StringResource by lazy {
      StringResource("string:nodin_instructions_step1", "nodin_instructions_step1", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 590, 76),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 726, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 726, 80),
      ))
    }

@delegate:ResourceContentHash(19_356_282)
internal val Res.string.nodin_instructions_step2: StringResource by lazy {
      StringResource("string:nodin_instructions_step2", "nodin_instructions_step2", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 667, 116),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 819, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 807, 144),
      ))
    }

@delegate:ResourceContentHash(363_400_400)
internal val Res.string.nodin_instructions_title: StringResource by lazy {
      StringResource("string:nodin_instructions_title", "nodin_instructions_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 784, 56),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 968, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 952, 68),
      ))
    }

@delegate:ResourceContentHash(-119_880_417)
internal val Res.string.nodin_network_body: StringResource by lazy {
      StringResource("string:nodin_network_body", "nodin_network_body", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 841, 58),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1029, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1021, 98),
      ))
    }

@delegate:ResourceContentHash(2_142_937_852)
internal val Res.string.nodin_network_title: StringResource by lazy {
      StringResource("string:nodin_network_title", "nodin_network_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 900, 47),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1128, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1120, 71),
      ))
    }

@delegate:ResourceContentHash(2_050_433_411)
internal val Res.string.nodin_open_app: StringResource by lazy {
      StringResource("string:nodin_open_app", "nodin_open_app", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 948, 46),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1200, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1192, 54),
      ))
    }

@delegate:ResourceContentHash(1_659_505_125)
internal val Res.string.nodin_or_divider: StringResource by lazy {
      StringResource("string:nodin_or_divider", "nodin_or_divider", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 995, 28),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1255, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1247, 36),
      ))
    }

@delegate:ResourceContentHash(1_005_761_336)
internal val Res.string.nodin_page_title: StringResource by lazy {
      StringResource("string:nodin_page_title", "nodin_page_title", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1024, 52),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1292, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1284, 68),
      ))
    }

@delegate:ResourceContentHash(-1_170_859_935)
internal val Res.string.nodin_qr_label: StringResource by lazy {
      StringResource("string:nodin_qr_label", "nodin_qr_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1077, 34),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1365, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1353, 38),
      ))
    }

@delegate:ResourceContentHash(-570_463_857)
internal val Res.string.nodin_retry: StringResource by lazy {
      StringResource("string:nodin_retry", "nodin_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1112, 27),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1404, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1392, 31),
      ))
    }

@delegate:ResourceContentHash(1_256_946_783)
internal val Res.string.nodin_start_badge: StringResource by lazy {
      StringResource("string:nodin_start_badge", "nodin_start_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1140, 45),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1436, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1424, 37),
      ))
    }

@delegate:ResourceContentHash(-1_342_958_121)
internal val Res.string.nodin_start_time_label: StringResource by lazy {
      StringResource("string:nodin_start_time_label", "nodin_start_time_label", setOf(
        ResourceItem(setOf(LanguageQualifier("en"), ), "${MD}values-en/strings.commonMain.cvr", 1186, 46),
        ResourceItem(setOf(LanguageQualifier("ja"), ), "${MD}values-ja/strings.commonMain.cvr", 1474, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1462, 46),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("landing_brand", Res.string.landing_brand)
  map.put("landing_footer", Res.string.landing_footer)
  map.put("landing_tagline", Res.string.landing_tagline)
  map.put("nodin_code_input_label", Res.string.nodin_code_input_label)
  map.put("nodin_display_code_label", Res.string.nodin_display_code_label)
  map.put("nodin_end_badge", Res.string.nodin_end_badge)
  map.put("nodin_end_expired_body", Res.string.nodin_end_expired_body)
  map.put("nodin_end_expired_title", Res.string.nodin_end_expired_title)
  map.put("nodin_end_not_found_body", Res.string.nodin_end_not_found_body)
  map.put("nodin_end_not_found_title", Res.string.nodin_end_not_found_title)
  map.put("nodin_end_time_label", Res.string.nodin_end_time_label)
  map.put("nodin_instructions_step1", Res.string.nodin_instructions_step1)
  map.put("nodin_instructions_step2", Res.string.nodin_instructions_step2)
  map.put("nodin_instructions_title", Res.string.nodin_instructions_title)
  map.put("nodin_network_body", Res.string.nodin_network_body)
  map.put("nodin_network_title", Res.string.nodin_network_title)
  map.put("nodin_open_app", Res.string.nodin_open_app)
  map.put("nodin_or_divider", Res.string.nodin_or_divider)
  map.put("nodin_page_title", Res.string.nodin_page_title)
  map.put("nodin_qr_label", Res.string.nodin_qr_label)
  map.put("nodin_retry", Res.string.nodin_retry)
  map.put("nodin_start_badge", Res.string.nodin_start_badge)
  map.put("nodin_start_time_label", Res.string.nodin_start_time_label)
}
